import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, user, onLogout, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      user ? (
        <Component {...props} user={user} onLogout={onLogout} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

export default ProtectedRoute;
